import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Numero di telefono',
      placeholder: 'Inserisci il numero di telefono',
    },
    email: {
      label: 'Indirizzo email',
      placeholder: 'Inserisci indirizzo email',
    },
  },
  channel_chooser: {
    title: 'Invia codice tramite',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratuito, consegna più rapida',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Messaggio di testo standard',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Email',
      subtitle: 'Il codice direttamente nella tua casella di posta',
    },
  },
  otp: {
    title: 'Inserisci il codice di verifica',
    send_code: 'Invia codice',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Inviato tramite <strong>WhatsApp</strong> a <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Inviato tramite <strong>SMS</strong> a <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Inviato tramite <strong>email</strong> a <strong>{{phone}}</strong>',
    },
    sent_to: 'Inviato a',
    resend: {
      title: 'Non hai ricevuto il codice?',
      countdown: 'Reinvia tra',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Non hai ricevuto il codice via email?',
          button: 'Invia di nuovo via email',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Non hai ricevuto il codice?',
          button: 'Reinvia via SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Non hai ricevuto il codice?',
          button: 'Reinvia via WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Invia via SMS',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Invia via WhatsApp',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Un messaggio con il codice di verifica è stato inviato al tuo telefono. Inserisci il codice per continuare.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Inserisci il codice inviato a questo indirizzo: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Un messaggio WhatsApp con il codice di verifica è stato inviato al tuo telefono. Inserisci il codice per continuare.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Suggerimento: controlla la posta in arrivo e la cartella spam.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Attenzione — il codice viene inviato da <strong>{{sender}}</strong>, il nostro partner tecnologico.',
    business_account: 'Account aziendale',
    message:
      '<strong>123456</strong> è il tuo codice di verifica. Per la tua sicurezza, non condividere questo codice.',
  },
  error_messages: {
    frequent_requests:
      'Controlla i tuoi messaggi. Abbiamo già inviato il codice al numero indicato. In caso contrario, verifica il numero di telefono o riprova tra 10 minuti.',
    frequent_requests_email:
      "Controlla la posta in arrivo e la cartella spam. Abbiamo già inviato il codice a quell'indirizzo. Se non è arrivato, riprova tra 10 minuti.",
    invalid_number: 'Numero non valido. Riprova.',
    invalid_email: "Non siamo riusciti a inviare il codice a quell'indirizzo email. Verificalo e riprova.",
    email_not_on_file:
      'Questo numero di telefono ha già un account senza indirizzo email. Contatta {{support_email}} per aggiungerne uno — fino ad allora non possiamo inviare codici per questo numero via email.',
    turnstile_required: 'Completa la verifica prima di richiedere un nuovo codice.',
    generic_error: 'Ops, qualcosa è andato storto. Aggiorna la pagina e riprova.',
    change_phone_number_unsuccessful: 'Modifica del numero di telefono non riuscita. Riprova.',
  },
  toasts: {
    code_sent: 'Codice inviato',
  },
};
